<template>
  <div class="d-block text-center" v-if="apiError">
    <span class="text-danger">Erreur connexion serveur. Veuillez réessayer plus tard.</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ApiErrorNotification',
  computed: {
    ...mapState(['apiError'])
  }
}
</script>
